import type { useTranslate } from '@src/core/hooks';

import { getFormattedItemDate } from './getFormattedItemDate';
import type { SummaryLineItem } from '@src/features/transactables/summary/core/summaryLineItem';

export const formatScheduleParts = (item: SummaryLineItem, i18n: ReturnType<typeof useTranslate>['i18n']) => {
  const formatted = getFormattedItemDate({ item, i18n });
  const parts = formatted.split(' - ');

  return {
    date: parts[0] ?? formatted,
    time: parts[1],
  };
};
